import { render } from "./CustomCalendar.vue?vue&type=template&id=aab3702a&scoped=true"
import script from "./CustomCalendar.vue?vue&type=script&lang=js"
export * from "./CustomCalendar.vue?vue&type=script&lang=js"

import "./CustomCalendar.vue?vue&type=style&index=0&id=aab3702a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aab3702a"]])

export default __exports__